import gql from "graphql-tag";

export const SEND_MAIL_LEGAL_PLACE = gql`
  mutation SendMailLegalplace($urlSucces: String!) {
    sendMailLegalplace(urlSucces: $urlSucces)
  }
`;
